/**
 * Artículos de la tienda: español.
 *
 * Sobre por qué este archivo va aparte, véase goods-ru.ts.
 *
 * ⚠️ NOMBRES DE TIENDA, NO DESCRIPCIONES. El pescador busca «caña feeder» o
 * «carrete con baitrunner»; algunos términos se usan en inglés en España
 * («boilies», «rod pod», «jerkbait») y traducirlos sonaría a manual.
 */
export const ТОВАРЫ_ES: Record<string, string> = {
  // ── было в общем словаре ──
  'item.test': 'hasta',
  'item.drag': 'freno hasta',
  'item.dive': 'profundidad',
  'item.action_fast': 'acción rápida',
  'item.action_medium': 'acción media',
  'item.action_slow': 'acción lenta',
  'item.mat_mono': 'monofilamento',
  'item.mat_fluoro': 'fluorocarbono',
  'item.mat_braid': 'trenzado',
  'item.rod_medium': 'Caña «Medium» 2,4 m',
  'item.rod_ultralight': 'Caña «Ultraligera» 1,98 m',
  'item.rod_light': 'Caña «Ligera» 2,13 m',
  'item.rod_heavy': 'Caña «Pesada» 2,7 m',
  'item.reel_stock': 'Carrete 2500',
  'item.reel_3000': 'Carrete 3000',
  'item.reel_4000': 'Carrete 4000',
  'item.line_mono_024': 'Monofilamento 0,24 mm',
  'item.line_mono_030': 'Monofilamento 0,30 mm',
  'item.line_fluoro_022': 'Fluorocarbono 0,22 mm',
  'item.line_braid_014': 'Trenzado 0,14 mm',
  'item.line_braid_020': 'Trenzado 0,20 mm',
  'item.lure_spoon_18': 'Cuchara 18 g',
  'item.lure_spinner_8': 'Giratorio 8 g',
  'item.lure_wobbler_12': 'Crankbait 12 g',
  'item.lure_wobbler_deep': 'Crankbait profundo 16 g',
  'item.lure_jig_14': 'Jig 14 g',
  'item.lure_jig_24': 'Jig 24 g',
  'item.lead_fluoro': 'Bajo de fluorocarbono 0,20 mm',
  'item.lead_steel': 'Bajo de acero 12 kg',
  'item.hook_10': 'Anzuelo n.º 10',
  'item.hook_8': 'Anzuelo n.º 8',
  'item.hook_6': 'Anzuelo n.º 6',
  'item.hook_4': 'Anzuelo n.º 4',
  'item.bait_corn': 'Maíz dulce',
  'item.bait_worm': 'Lombriz roja',
  'item.bait_maggot': 'Gusanos',
  'item.bait_fry': 'Pez vivo',
  'item.gb_basic': 'Cebo básico',
  'item.gb_aroma': 'Cebo aromatizado',
  'item.food_sandwich': 'Bocadillo',
  'item.food_tea': 'Termo de té',
  'item.food_stew': 'Estofado en lata',
  'item.food_ration': 'Ración diaria',
  'item.keep_150': 'Nasa para 150',
  'item.keep_250': 'Nasa para 250',
  'item.keep_400': 'Nasa para 400',
  'item.sonar_shore': 'Sonda de orilla',
  'item.sonar_far': 'Sonda de largo alcance',
  'item.boat_row': 'Barca de remos',
  'item.boat_motor': 'Barca a motor',
  'item.net_small': 'Sacadera pequeña',
  'item.net_big': 'Sacadera grande',
  'item.lamp_head': 'Linterna frontal',
  'item.lamp_camp': 'Farol de campamento',
  'item.tent_solo': 'Tienda individual',
  'item.tent_duo': 'Tienda doble',
  'item.cloth_rain': 'Chubasquero',
  'item.cloth_warm': 'Traje térmico',
  'item.gear_chair': 'Silla plegable',
  'item.gear_box': 'Caja de aparejos',
  'item.gear_thermos': 'Termo',
  'item.gear_scales': 'Báscula',
  'item.gear_tape': 'Cinta métrica',
  'item.gear_stringer': 'Cadena de pesca',


  // ── удилища ──
  'item.rod_spin_ul_21': 'Caña de spinning ultraligera 2,10 m',
  'item.rod_spin_jig_27': 'Caña de jigging 2,70 m',
  'item.rod_spin_twitch_21': 'Caña de twitching 2,10 m',
  'item.rod_spin_sea_30': 'Caña de spinning pesada 3,00 m',
  'item.rod_feeder_33': 'Caña feeder ligera 3,30 m',
  'item.rod_feeder_36': 'Caña feeder media 3,60 m',
  'item.rod_feeder_39': 'Caña feeder pesada 3,90 m',
  'item.rod_match_42': 'Caña de match 4,20 m',
  'item.rod_bolo_50': 'Caña boloñesa 5,00 m',
  'item.rod_pole_60': 'Caña de tralla 6,00 m',
  'item.rod_carp_36': 'Caña de carpfishing 3,60 m',
  'item.rod_fly_5': 'Caña de mosca del 5',
  'item.rod_fly_8': 'Caña de mosca del 8',
  'item.rod_tele_40': 'Caña telescópica 4,00 m',
  'item.rod_troll_24': 'Caña de curricán 2,40 m',
  'item.rod_ice': 'Caña de hielo',

  // ── катушки ──
  'item.reel_1000': 'Carrete 1000',
  'item.reel_2000': 'Carrete 2000',
  'item.reel_5000': 'Carrete 5000',
  'item.reel_8000': 'Carrete 8000',
  'item.reel_baitrunner': 'Carrete con baitrunner',
  'item.reel_feeder': 'Carrete feeder',
  'item.reel_rear_drag': 'Carrete de freno trasero',
  'item.reel_carp_big': 'Carrete de carpfishing',
  'item.reel_multi': 'Carrete multiplicador',
  'item.reel_troll': 'Carrete de curricán',
  'item.reel_fly': 'Carrete de mosca',
  'item.reel_ice': 'Carrete de hielo',

  // ── леска ──
  'item.line_mono_016': 'Monofilamento 0,16 mm',
  'item.line_mono_020': 'Monofilamento 0,20 mm',
  'item.line_mono_028': 'Monofilamento 0,28 mm',
  'item.line_mono_035': 'Monofilamento 0,35 mm',
  'item.line_fluoro_018': 'Fluorocarbono 0,18 mm',
  'item.line_fluoro_028': 'Fluorocarbono 0,28 mm',
  'item.line_braid_010': 'Trenzado 0,10 mm',
  'item.line_braid_025': 'Trenzado 0,25 mm',
  'item.line_feeder_022': 'Hilo feeder 0,22 mm',
  'item.line_carp_030': 'Hilo de carpfishing 0,30 mm',
  'item.line_ice_012': 'Hilo de hielo 0,12 mm',
  'item.line_shock': 'Línea de choque',

  // ── поводки ──
  'item.lead_mono': 'Bajo de línea de monofilamento 0,16 mm',
  'item.lead_titan': 'Bajo de línea de titanio, 9 kg',
  'item.lead_tungsten': 'Bajo de línea de tungsteno, 7 kg',
  'item.lead_kevlar': 'Bajo de línea de kevlar, 15 kg',
  'item.lead_carp': 'Bajo de línea trenzado para carpa',
  'item.lead_fly': 'Bajo de línea cónico de mosca',

  // ── крючки ──
  'item.hook_14': 'Anzuelo del 14',
  'item.hook_12': 'Anzuelo del 12',
  'item.hook_2': 'Anzuelo del 2',
  'item.hook_1_0': 'Anzuelo del 1/0',
  'item.hook_treble': 'Anzuelo triple',
  'item.hook_double': 'Anzuelo doble',
  'item.hook_offset': 'Anzuelo offset',
  'item.hook_carp': 'Anzuelo para carpa',

  // ── приманки ──
  'item.lure_spoon_7': 'Cuchara de 7 g',
  'item.lure_spoon_28': 'Cuchara de 28 g',
  'item.lure_spinner_3': 'Cucharilla giratoria de 3 g',
  'item.lure_spinner_14': 'Cucharilla giratoria de 14 g',
  'item.lure_minnow_90': 'Señuelo minnow de 90 mm',
  'item.lure_crank_60': 'Crankbait de 60 mm',
  'item.lure_shad_70': 'Señuelo shad de 70 mm',
  'item.lure_popper_80': 'Popper de 80 mm',
  'item.lure_walker_95': 'Señuelo walker de 95 mm',
  'item.lure_jerk_130': 'Jerkbait de 130 mm',
  'item.lure_swim_150': 'Swimbait articulado de 150 mm',
  'item.lure_jighead_12': 'Cabeza de jig de 12 g',
  'item.lure_sil_worm': 'Vinilo tipo gusano',
  'item.lure_sil_shad': 'Vinilo tipo shad',
  'item.lure_sil_twister': 'Vinilo tipo grub',
  'item.lure_mandula': 'Señuelo mandula',
  'item.lure_fly_wet': 'Mosca ahogada',
  'item.lure_fly_dry': 'Mosca seca',

  // ── наживка ──
  'item.bait_bloodworm': 'Larva roja',
  'item.bait_barley': 'Cebada perlada',
  'item.bait_dough': 'Masa',
  'item.bait_peas': 'Guisantes',
  'item.bait_boilie': 'Boilies',
  'item.bait_pellets': 'Pellets',
  'item.bait_mussel': 'Almeja de río',
  'item.bait_shrimp': 'Camarón de río',
  'item.bait_bread': 'Miga de pan',
  'item.bait_cheese': 'Queso',

  // ── прикормка ──
  'item.gb_bream': 'Engodo para brema',
  'item.gb_carp': 'Engodo para carpa',
  'item.gb_roach': 'Engodo para bermejuela',
  'item.gb_feeder': 'Engodo feeder',
  'item.gb_winter': 'Engodo de invierno',
  'item.gb_dip': 'Atrayente en dip',
  'item.gb_pva': 'Bolsas de PVA',
  'item.gb_soil': 'Tierra para engodo',

  // ── еда ──
  'item.food_soup': 'Olla de sopa de pescado',
  'item.food_coffee': 'Café',
  'item.food_energy': 'Bebida energética',
  'item.food_bar': 'Barrita de cereales',

  // ── садки ──
  'item.keep_60': 'Nasa de 60 cm',
  'item.keep_cage': 'Nasa engomada',
  'item.keep_sack': 'Saco para carpa',

  // ── эхолоты ──
  'item.sonar_wireless': 'Sonda inalámbrica',
  'item.sonar_color': 'Sonda en color con cartografía',
  'item.sonar_ice': 'Sonda de hielo',

  // ── лодки ──
  'item.boat_pvc': 'Barca hinchable de PVC',
  'item.boat_outboard': 'Motor fueraborda',
  'item.boat_mount': 'Soporte para la sonda',
  'item.boat_anchor': 'Ancla de barca',

  // ── снаряжение ──
  'item.gear_forceps': 'Desanzuelador',
  'item.gear_pliers': 'Alicates de pesca',
  'item.gear_mat': 'Colchoneta para carpa',
  'item.gear_rodpod': 'Rod pod',
  'item.gear_umbrella': 'Paraguas de pesca',
  'item.gear_bag': 'Bolsa de aparejos',
  'item.gear_bucket': 'Cubo para engodo',
  'item.gear_polar': 'Gafas polarizadas',

  // ── нахлыст: вторая сотня видов ──
  'item.fly_line_5': 'Línea de mosca del 5',
  'item.fly_line_8': 'Línea de mosca del 8',
  'item.fly_backing': 'Backing de mosca',
  'item.fly_tippet': 'Material de bajos',
  'item.fly_box': 'Caja de moscas',
  'item.fly_dry_set': 'Juego de moscas secas',
  'item.fly_wet_set': 'Juego de moscas ahogadas',
  'item.fly_nymph_set': 'Juego de ninfas',
  'item.fly_streamer': 'Streamer',
  'item.fly_hegene': 'Aparejo hegene de ninfas',
  'item.fly_floatant': 'Flotante para moscas',
  'item.fly_sink': 'Pasta de hundimiento',
  'item.fly_vice': 'Torno de montaje de moscas',

  // ── наживка: вторая сотня видов ──
  'item.bait_caddis': 'Larva de frigánea',
  'item.bait_roe': 'Huevas de salmón',
  'item.bait_cut': 'Pez cortado',
  'item.bait_grasshopper': 'Saltamontes',
  'item.bait_algae': 'Algas filamentosas',
  'item.bait_frog': 'Rana viva',
  'item.bait_fruit': 'Cebo de fruta',
  'item.bait_meat': 'Cebo de carne',
  'item.bait_mussel_tropic': 'Almeja de río grande',

  // ── поводки: вторая сотня видов ──
  'item.lead_wire_20': 'Bajo de acero, 20 kg',
  'item.lead_wire_40': 'Bajo de acero, 40 kg',
  'item.lead_shock_heavy': 'Bajo de choque, 60 kg',
  'item.lead_mono_heavy': 'Bajo de monofilamento, 1,0 mm',

  // ── крючки: вторая сотня видов ──
  'item.hook_3_0': 'Anzuelo del 3/0',
  'item.hook_6_0': 'Anzuelo del 6/0',
  'item.hook_circle': 'Anzuelo circular',
  'item.hook_fly': 'Anzuelo de montaje',

  // ── снаряжение: вторая сотня видов ──
  'item.gear_waders': 'Vadeador de pecho',
  'item.gear_boots': 'Botas de vadeo',
  'item.gear_glove': 'Guante de manipulación',
  'item.gear_lipgrip': 'Pinza labial para peces',
  'item.gear_gaff': 'Bichero',
  'item.gear_cooler': 'Bolsa nevera',
  'item.gear_repellent': 'Repelente de insectos',
  'item.gear_marker': 'Flotador marcador',

  'item.float_light_1g': "Flotador ligero 1 g",
  'item.float_mid_3g': "Flotador medio 3 g",
  'item.float_heavy_6g': "Flotador pesado 6 g",

  'item.float_quill_05': 'Flotador de pluma 0,5 g',
  'item.float_waggler_4g': 'Waggler 4 g',
  'item.float_slider_8g': 'Flotador deslizante 8 g',
  'item.rod_pole_90': 'Caña de tramos 9,00 m',
};
